import React from 'react';
import {Grid,Chip} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment'
import {isEmpty} from 'lodash'
import { injectIntl } from 'react-intl';

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      padding: theme.spacing(2),
    }
  }));
function ChipsList(props) {
    console.log(props)
    const classes = useStyles();
    const DateFrom = props.intl.formatMessage({ id: 'Chips.Date.from' });
    const DateTo = props.intl.formatMessage({ id: 'Chips.Date.to' });
    const GetMeta =(Meta)=>{
        switch(Meta){
           case "DatumFrom":return DateFrom
            case "DatumTo":return DateTo
        }
    }
    const GetValue =(n)=>{
        switch(n.Meta){
            case "DatumFrom":return moment(n.Value).format("YYYY-MM-DD")
            case "DatumTo":return moment(n.Value).format("YYYY-MM-DD")
            default: return `${n.Value}`
        }
    }
   
    const handleDelete=(n)=>{
        props.handleDeleteOptions(n)
    }
    return (
        <Grid container className={classes.root} spacing={2}>
           {    
                isEmpty(props.Chips)?"":
               props.Chips.map(n=>{
                   return (
                    <Grid item spacing={1} >
                        <Chip 
                        color="primary" 
                        size="small" 
                        style={{background:"#0c969c", color:"#fff",borderRadius:"0"}}
                        label={`${GetMeta(n.Meta)}: ${GetValue(n)}`}
                        onDelete={()=>handleDelete(n)} 
                        />
                    </Grid>
                   )
               })
           } 
        </Grid>
    );
}

export default injectIntl(ChipsList);